<template>
  <!-- 选择订单来源 -->
  <jczh-drawer
    :visible.sync="drawerVisible"
    title="选择订单来源"
    confirm-button-text="确定"
    size="1000px"
    :el-attrs="{
      destroyOnClose: true
    }"
    @close="handleDrawerClose"
    @confirm="handleConfirm"
  >
    <template slot="content">
      <div class="m-t-20">
        <el-form :model="filterForm" :inline="true" label-suffix="：">
          <el-form-item label="采购方案名称/编号">
            <el-input
              v-model.trim="filterForm.planCodeOrName"
              placeholder="请输入采购方案名称"
              clearable
            />
          </el-form-item>
          <el-form-item label="采购方式">
            <el-select v-model="filterForm.purchaseMethod" clearable>
              <el-option value="">全部</el-option>
              <el-option
                v-for="item in purchasePlanMethodDict.array"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </el-form-item>
        </el-form>

        <jczh-table-content
          ref="table"
          :data="tableList"
          :option="tableConfig"
          pagination
          :page.sync="page"
          :limit.sync="size"
          :total="total"
          highlight-current-row
          @current-change="handleCurrentChange"
        />
      </div>
    </template>
    <template slot="footer">
      <div style="width: 100%;text-align: right;">
        <el-button
          style="width: 60px"
          @click="handleDrawerClose"
        >取消</el-button>
        <el-button
          style="width: 60px"
          type="primary"
          @click="handleConfirm"
        >确定</el-button>
      </div>
    </template>
  </jczh-drawer>
</template>

<script>
// 数据字典
import { purchaseOrderSourceTypeDict } from '@/dictionary/order'
import { purchasePlanMethodDict } from '@/dictionary/purchase-demand'

// 后端api
import { getWinnerSupplierResultDetailApi } from '@/api/procure/inquiry'
import { getPurchasePlanDetailApi } from '@/api/purchase-demand/plan'
import { getPurchaseRelationOrderPlanListApi } from '@/api/order-views/order'
import { strToThousands } from '@/utils/utils'

export default {
  name: 'SelectOrderDrawer',

  data() {
    return {
      // 数据字典
      purchasePlanMethodDict,
      activeName: purchasePlanMethodDict.ORDER.name,

      drawerVisible: false,

      // 查询表单
      filterForm: {
        planCodeOrName: '',
        purchaseMethod: ''
      },

      page: 1,
      size: 10,

      tableList: [],
      tableConfig: [
        { label: '采购方案名称', prop: 'planName', minWidth: 140 },
        { label: '采购方案编号', prop: 'planCode', minWidth: 120 },
        {
          label: '采购方式',
          prop: 'purchaseMethod',
          tagDict: purchasePlanMethodDict
        },
        {
          label: '预算总额(元)',
          prop: 'planBudget',
          minWidth: 140,
          filter: value => strToThousands(value)
        },
        { label: '采购类别', prop: 'categoryName', minWidth: 100 },
        { label: '方案创建时间', prop: 'completeTime', minWidth: 160 }
      ],
      total: 0,
      currentRow: {},
      initRow: {} // 之前选中的行
    }
  },

  methods: {
    /**
     * 打开抽屉
     */
    open(data = {}) {
      this.drawerVisible = true
      this.handleSearch()
      this.initRow = { ...data }
    },

    /**
     * 关闭抽屉
     */
    handleDrawerClose() {
      this.drawerVisible = false
    },

    /**
     * 点击查询按钮
     */
    handleSearch() {
      this.page = 1
      this.size = 10
      this.getList()
    },

    /**
     * 获取列表
     */
    async getList() {
      const params = Object.assign({}, this.filterForm, {
        page: this.page,
        size: this.size
      })
      try {
        const { data } = await getPurchaseRelationOrderPlanListApi(params)
        this.tableList = data?.records || []
        this.total = data?.total || 0
        const row = this.tableList.find(el => {
          if (
            this.initRow.sourceType === purchaseOrderSourceTypeDict.PLAN.value
          ) {
            // 定点采购
            return (
              this.initRow.sourceType === el.sourceType &&
              this.initRow.sourceOrderId === el.planId
            )
          } else {
            // 询比采购
            return (
              this.initRow.sourceType === el.sourceType &&
              this.initRow.sourceOrderId === el.purchaseOrderId
            )
          }
        })
        this.$refs.table.$refs?.table?.setCurrentRow(row)
      } catch (e) {
        this.$message.error(e.message)
      }
    },

    /**
     * 选择项目
     */
    handleCurrentChange(row) {
      this.currentRow = row
    },

    /**
     * 确认选出的订单来源数据
     */
    handleConfirm() {
      if (!this.currentRow.planId) {
        this.$message.warning('请选择订单来源')
        return
      }
      // 定点采购
      if (
        this.currentRow.purchaseMethod === purchasePlanMethodDict.ORDER.value
      ) {
        this.getPurchaseDetail()
      } else if (
        this.currentRow.purchaseMethod === purchasePlanMethodDict.INQUIRY.value
      ) {
        // 询比采购
        this.getInquiryDetail()
      }
    },

    /**
     * 查询定点采购的详情
     */
    async getPurchaseDetail() {
      try {
        const _data = await getPurchasePlanDetailApi(this.currentRow.planId)
        this.$emit(
          'confirmed',
          _data.data,
          purchaseOrderSourceTypeDict.PLAN.value
        )
        this.handleDrawerClose()
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 查询询比单的详情
     */
    async getInquiryDetail() {
      try {
        const [
          { data: inquiryData = {} },
          { data: planData = {} }
        ] = await Promise.all([
          getWinnerSupplierResultDetailApi({
            orderId: this.currentRow.purchaseOrderId
          }),
          getPurchasePlanDetailApi(this.currentRow.planId)
        ])

        const itemObject = {}
        planData.itemList.forEach(item => {
          itemObject[item.itemId] = {
            requirementCode: item.requirementCode,
            requirementName: item.requirementName,
            requirementPhone: item.requirementPhone
          }
        })

        inquiryData.supplierList.forEach(supplier => {
          supplier.resultItems = supplier.resultItems.map(item => {
            return {
              ...item,
              ...(itemObject[item.itemId] || {})
            }
          })
        })

        this.$emit(
          'confirmed',
          {
            ...inquiryData,
            categoryCode: this.currentRow.categoryCode,
            categoryName: this.currentRow.categoryName
          },
          purchaseOrderSourceTypeDict.INQUIRY.value
        )
        this.handleDrawerClose()
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>
